import React from 'react';
import OutsourcedUserFteItem from '../../../Domain/OutsourcedUserFte/OutsourcedUserFteItem';
import OutsourcedUserFteService from '../../../Services/OutsourcedUserFte/OutsourcedUserFteService';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import EditOutsourcedUserFteWindowDescription from './EditOutsourcedUserFteWindowDescription';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OutsourcedUserFteSearchParams from './OutsourcedUserFteSearchParams';

class OutsourcedUserFteAdmin extends React.Component {
  static defaultProps = {
    userId: 0,
    officeId: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      shownPanel: ShownPanelsEnum.None,
      selectedItem: null,
      searchItem: new OutsourcedUserFteSearchParams(props.userId),
    };

    this.refresh = this.refresh.bind(this);
    this.createFunction = this.createFunction.bind(this);
    OutsourcedUserFteItem.editFunction = this.editFunction.bind(this);
    OutsourcedUserFteItem.deleteFunction = this.deleteFunction.bind(this);
  }

  refresh(doRefresh) {
    if (doRefresh) {
      this.setState({ shownPanel: ShownPanelsEnum.None, selectedItem: null, searchItem: { ...this.state.searchItem } });
    } else {
      this.setState({ shownPanel: ShownPanelsEnum.None, selectedItem: null });
    }
  }

  createFunction() {
    const newItem = new OutsourcedUserFteItem();
    newItem.UserId = this.props.userId;
    newItem._userOfficeId = this.props.officeId;
    newItem.HiringOfficeId = this.props.officeId;
    newItem.Status = 'Open';
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const lastDate = new Date(y, now.getMonth() + 1, 0).getDate();
    newItem.StartDateUtc = `${y}-${m}-01`;
    newItem.EndDateUtc = `${y}-${m}-${String(lastDate).padStart(2, '0')}`;
    this.setState({
      selectedItem: newItem,
      shownPanel: ShownPanelsEnum.AddNewItem,
    });
  }

  editFunction(selectedId, selectedItem) {
    this.setState({
      selectedItem: {
        ...selectedItem,
        _userOfficeId: this.props.officeId,
        HiringOfficeId: selectedItem.HiringOfficeId || this.props.officeId,
      },
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  deleteFunction(item) {
    ErrorMessage.SetApprove('Are you sure you want to delete this FTE entry?', () => {
      OutsourcedUserFteService.Delete(item.OutsourcedUserFteid)
        .then((response) => {
          if (response && response.error) {
            ErrorMessage.SetErrorMessage(response.error);
          } else {
            ErrorMessage.SetNotification('FTE entry deleted successfully.');
            this.refresh(true);
          }
        })
        .catch(() => {
          ErrorMessage.SetErrorMessage('Error! ErrorCode: OUFTE02. Failed to delete FTE entry. Please notify IT!');
        });
    });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditOutsourcedUserFteWindowDescription}
            errorCode={'OUFTE03'}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditOutsourcedUserFteWindowDescription}
            errorCode={'OUFTE04'}
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        <FigmaButtonRow
          className={'InnerMenuButtonFigmaList'}
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Right,
              onClick: this.createFunction,
              label: 'Add FTE Entry',
              tooltip: 'Add FTE Entry',
              roleKey: 'outsourcedfte_edit',
              iconName: 'fa-solid fa-plus-circle',
            },
          ]}
        />
        {this.renderPanels()}
        <TabOfDataTable
          type={OutsourcedUserFteItem}
          searchParamsType={OutsourcedUserFteSearchParams}
          shownPanel={this.state.shownPanel}
          serviceFunction={OutsourcedUserFteService.GetListBySearching}
          convertDBItemsFunction={OutsourcedUserFteService.ConvertDBItems}
          searchItem={this.state.searchItem}
          showSearchStrip={true}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search...'
          clickOnStartSearch={(searchItem) => {
            searchItem.UserId = this.props.userId;
            this.setState({ searchItem });
          }}
          orderBy='StartDateUtc'
          orderDirection='Desc'
          enableUrlPush={false}
          errorCode='OUFTE50'
        />
      </div>
    );
  }
}

export default OutsourcedUserFteAdmin;
